var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cart", on: { click: _vm.handleClick } }, [
    _c("a", { attrs: { href: "javascript:void(0)" } }, [
      _c(
        "div",
        { staticClass: "cart-image" },
        [
          _c("NsIcon", {
            staticStyle: { width: "100%", height: "100%" },
            attrs: {
              "icon-name": _vm.iconName,
              color: "#272525",
              size: "icon-lg"
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "cart-count" }, [
            _vm._v(_vm._s(_vm.countDisplay))
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }